"use client"

import { useState } from "react"
import { addItemToCart } from "src/checkout/hooks/useCart"
import { NpButton } from "src/components/np-design/components/NpButton"
import { formatPriceShort } from "src/utilities/price"

export type AddToCartButtonProps = {
  resolvedId: number
  price: number
  available: boolean | undefined
  text?: string
}

export const AddToCartButton = ({ resolvedId, price, available, text }: AddToCartButtonProps) => {
  const [adding, setAdding] = useState(false)

  return (
    <>
      <NpButton
        disabled={!available}
        title={available ? undefined : "Nicht verfügbar"}
        color={available ? "green" : "gray75"}
        loading={adding}
        onClick={async () => {
          setAdding(true)
          await addItemToCart(resolvedId)
          setAdding(false)
        }}
      >
        {available ? (text ?? "In den Warenkorb | " + formatPriceShort(price)) : "Nicht verfügbar"}
      </NpButton>
    </>
  )
}
